import {TileLayer} from "react-leaflet/TileLayer";
import {MapContainer} from "react-leaflet/MapContainer";
import {Pane} from "react-leaflet";
import React, {useEffect, useMemo, useRef, useState} from "react";
import * as Const from "../Const";
import OverviewMapMachineMarkers from "./OverviewMapMachineMarkers";
import {calculateAverage, calculateBounds} from "../utils/OwnMath";
import OverviewMapParcelPolygonsV2 from "./OverviewMapParcelPolygonsV2";
import useDictionaryFilter from "../hooks/useDictionaryFilter";
import OverviewMapParcelEditor from "./OverviewMapParcelEditor";
import {SHOW_UNFINISHED_STUFF} from "../Const";


function OverviewMapV4( {parcels, hiddenParcels, parcelFilter, selectedFieldName, onParcelClicked,
                            machines, livePositions, velocities, navigationSkills, workConfigurations, selectedMachineName, onMachineClicked,
                            editedParcel, onEditedParcelSaveClicked, onEditedParcelCancelClicked,
                            updateCounter, children} ) {

    const TAG = "MAPv4";

    const mapRef = useRef(null);
    const savedSelectedFieldName = useRef(null);

    const [updates, setUpdates] = useState(0);

    useEffect(() => {
        setUpdates(updates => updates + 1);
    }, [hiddenParcels, parcels, hiddenParcels, parcelFilter, machines, livePositions, velocities, navigationSkills, workConfigurations, selectedMachineName, selectedFieldName, editedParcel]);

    const flatParcels = useMemo(() => {
        // console.log("MAPv3", "update flat parcels");
        return parcels ? Object.values(parcels).flat() : [];
    }, [parcels]);

    const filteredParcels = useDictionaryFilter(flatParcels, 'parcel_name', parcelFilter);

    const filteredParcelsWithVisibility = useMemo(() => {
        return filteredParcels
            .filter(item => item !== editedParcel)
            .map(item => ({...item, is_visible: !hiddenParcels.has(item.field_name)}));
    }, [editedParcel, filteredParcels, hiddenParcels]);


    if (selectedFieldName) {
        if (savedSelectedFieldName.current !== selectedFieldName) {
            const parcel = flatParcels.find(p => p.field_name === selectedFieldName);
            console.log("MAPv3 selected parcel", parcel);
            if (parcel) {
                const { min, max } = calculateBounds(parcel['hull']);
                const average = calculateAverage([min, max]);
                // console.log("MAPv3 moving to parcel");
                mapRef.current.setView(average);
            }
        }
    } else if (selectedMachineName && !selectedFieldName) {
        const pos = livePositions[selectedMachineName];
        // console.log("MAPv3 selected machine pos", pos);
        if (pos && pos.latitude && pos.longitude) {
            // console.log("MAPv3 moving to machine");
            mapRef.current.setView([pos.latitude, pos.longitude]);
        }
    }

    useEffect(() => {
        savedSelectedFieldName.current = selectedFieldName;
    }, [selectedFieldName]);

    return(
        <>
            <MapContainer center={[49.441437, 7.716687]} zoom={18} maxZoom={22} scrollWheelZoom={true} id={"map"} ref={mapRef} editable={true}>
                <TileLayer
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    referrerPolicy="origin"
                    maxNativeZoom={19}
                    maxZoom={22}
                />

                <Pane name={Const.PANE_NAME_PARCELS} style={{ zIndex: 410 }} />
                <Pane name={Const.PANE_NAME_SELECTED_PARCELS} style={{ zIndex: 420 }} />
                <Pane name={Const.PANE_NAME_MACHINES} style={{ zIndex: 430 }} />
                <Pane name={Const.PANE_NAME_PARCEL_EDITOR_FENCE} style={{ zIndex: 440 }} />
                <Pane name={Const.PANE_NAME_PARCEL_EDITOR_WORK} style={{ zIndex: 441 }} />

                <OverviewMapMachineMarkers
                    mapReference={mapRef}
                    velocities={velocities}
                    workConfigurations={workConfigurations}
                    navigationSkills={navigationSkills}
                    machines={machines}
                    livePositions={livePositions}
                    onMachineClicked={onMachineClicked}
                    selectedMachineName={selectedMachineName}
                />

                <OverviewMapParcelPolygonsV2
                    mapReference={mapRef}
                    parcelsWithVisibility={filteredParcelsWithVisibility}
                    onParcelClicked={onParcelClicked}
                    selectedMachineName={selectedMachineName}
                    selectedFieldName={selectedFieldName}
                    workConfigurations={workConfigurations}
                />

                <OverviewMapParcelEditor
                    mapReference={mapRef}
                    editedParcel={editedParcel}
                    onEditedParcelSaveClicked={onEditedParcelSaveClicked}
                    onEditedParcelCancelClicked={onEditedParcelCancelClicked}
                />

            </MapContainer>

            {SHOW_UNFINISHED_STUFF ?
                <div className={"position-absolute start-0 bottom-0 m-2 bg-light"} style={{zIndex: Const.PANEL_OVERLAY_Z + 20}}>[{TAG} {updates}]</div>
                : null
            }
        </>
    );


}


export default OverviewMapV4;